import { Target, Eye } from "lucide-react";
import { useState } from "react";

const items = [
  {
    icon: Target,
    title: "Mission",
    description:
      "To turn agricultural challenges into opportunities across Sub-Saharan Africa by combining science, innovation, and local knowledge. We aim to deploy patented tech to eliminate waste, build robust community value chains, and empower local enterprise from soil to solution.",
  },
  {
    icon: Eye,
    title: "Vision",
    description:
      "We envision a Sub-Saharan Africa where every community has access to nutritious food, every farmer earns more from what they produce, and every harvest creates opportunity instead of waste. Our goal is to build stronger food systems that improve health, create jobs, protect the environment, and unlock prosperity for generations to come.",
  },
];

function Features() {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const selected = items[selectedIndex];

  return (
    <section className="max-w-6xl mx-auto px-6 sm:px-8 pb-16 sm:pb-24">
      {/* Mobile view selector */}
      <div className="flex gap-2 mb-4 sm:hidden">
        {items.map(({ title }, index) => (
          <button
            key={title}
            onClick={() => setSelectedIndex(index)}
            className={`px-4 py-2 rounded-full text-sm font-medium border transition-colors ${
              selectedIndex === index
                ? "bg-forest text-canvas border-forest"
                : "border-forest/20 text-ink/70"
            }`}
          >
            {title}
          </button>
        ))}
      </div>

      <p className="text-ink/70 leading-relaxed sm:hidden text-justify text-sm">
        {selected.description}
      </p>

      {/* Desktop view split cards */}
      <div className="hidden sm:grid grid-cols-2 gap-6">
        {items.map(({ icon: Icon, title, description }, index) => (
          <button
            key={title}
            onClick={() => setSelectedIndex(index)}
            className={`text-left rounded-2xl border p-8 transition-colors ${
              selectedIndex === index
                ? "border-forest bg-forest/5"
                : "border-forest/15 bg-white/40"
            }`}
          >
            <Icon className="w-7 h-7 text-forest mb-4" />
            <h3 className="font-display text-2xl text-forest mb-2">{title}</h3>
            <p className="text-ink/70 leading-relaxed text-sm lg:text-base">{description}</p>
          </button>
        ))}
      </div>
    </section>
  );
}

export default Features;